import { render, staticRenderFns } from "./cDocumentHeader.vue?vue&type=template&id=12bc1712&scoped=true"
import script from "./cDocumentHeader.vue?vue&type=script&lang=js"
export * from "./cDocumentHeader.vue?vue&type=script&lang=js"
import style0 from "./cDocumentHeader.vue?vue&type=style&index=0&id=12bc1712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bc1712",
  null
  
)

export default component.exports